<template>
    <nav id="sidebar">
        <div class="sidebar-header">
            <nuxt-link to="/dashboard">
                <img id="wide-logo" src="/siperLOCK_logo.png" alt="title" width="100%">
                <img id="small-logo" src="/siperLOCK-Favicon.png" alt="title" width="100%">
            </nuxt-link>

            <h2 v-if="environment !== 'production'" class="environment-label">{{ environment }}</h2>
        </div>

        <ul class="nav">
            <router-link v-for="(link,index) in sidebarLinks"
                         :id="link.name + '-link'"
                         :key="link.name + index"
                         class="nav-link"
                         :to="link.path"
                         tag="li"
            >
                <i class="material-icons">{{ link.icon }}</i>
                <span class="link-text">{{ link.name }}</span>
            </router-link>
        </ul>
    </nav>
</template>

<script>
import { checkPermission, PermissionsEnum } from '~/utils/permissionsHelper.js';
import config from '~/config/config';

export default {
    props: {
        user: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            sidebarLinks: [],
            environment: config.environment,
        };
    },
    watch: {
        user: {
            // the callback will be called immediately after the start of the observation
            immediate: true,
            // eslint-disable-next-line no-unused-vars
            handler (val, oldVal) {
                // val only if logged in
                if (val) {

                    // Clear sidebar links with each change to the user object.
                    this.sidebarLinks = [];

                    this.sidebarLinks.push({
                        name: 'Dashboard',
                        path: '/dashboard',
                        icon: 'dashboard'
                    });

                    if (checkPermission(val, PermissionsEnum.ViewReports)) {
                        this.sidebarLinks.push({
                            name: 'Reports',
                            path: '/reports',
                            icon: 'insert_chart_outlined'
                        });
                    }

                    this.sidebarLinks.push({
                        name: 'Devices',
                        path: '/devices',
                        icon: 'phone_android'
                    });

                    // The Messaging page can only be accessed if the user
                    // has Messaging enabled on their devices. Or by Conversa
                    // employees.
                    if (val.isConversaEmployee || (checkPermission(val, PermissionsEnum.SendMessages) && val.messaging)) {
                        this.sidebarLinks.push({
                            name: 'Messaging',
                            path: '/messaging',
                            icon: 'message'
                        });
                    }

                    // The Upload CSV page can only be accessed if user can Lock/Unlock Devices
                    if (val.isConversaEmployee || checkPermission(val, PermissionsEnum.LockUnlockDevices)) {
                        this.sidebarLinks.push({
                            name: 'Upload CSV',
                            path: '/upload',
                            icon: 'cloud_upload'
                        });
                    }

                    this.sidebarLinks.push({
                        name: 'Brands',
                        path: '/brands',
                        icon: 'tv',
                    });

                    // Admin: Conversa or Customer
                    if (checkPermission(val, PermissionsEnum.CreateUsers)) {
                        this.sidebarLinks.push({
                            name: 'Admin',
                            // path: val.isConversaEmployee ? '/conversa' : '/admin',
                            path: '/admin',
                            icon: 'people_outline'
                        });
                    }

                    // The Upload CSV page can only be accessed if user can Lock/Unlock Devices
                    if (val.isConversaEmployee) {
                        this.sidebarLinks.push({
                            name: 'Conversa',
                            path: '/conversa',
                            icon: 'business'
                        });
                    }

                    this.sidebarLinks.push({
                        name: 'Account Settings',
                        path: '/settings',
                        icon: 'settings',
                    });

                    this.$emit('links-updated', this.sidebarLinks);
                }
            }
        }
    },
};
</script>

<style scoped>

.environment-label {
    background: #004085;
    text-align: center;
    margin-top: 15px;
    border: 3px solid #ffffff;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 1);
}

#sidebar {
    min-width: 300px;
    max-width: 300px;
    min-height: 100vh;
    overflow: auto;
    display: block;

    /* background: #7386D5; */
    background: linear-gradient(180deg,#35495e,#40b782);
    color: #fff;
    transition: all 0.3s;
}
/*
#sidebar.active {
    min-width: 80px;
    max-width: 80px;
    text-align: center;
} */

.sidebar-header {
    padding: 10px 5px;
    margin: 0 20px;
    border-bottom: 1px solid hsla(0,0%,100%,.2);
    position: relative;
    z-index: 4;
}

#small-logo {
    display: none;
}

ul.nav {
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
    margin-top: 20px;
    float: none;
    display: block;
}

.nav li:hover {
    background: hsla(0,0%,100%,.13);
    opacity: 1;
}

li.nuxt-link-active {
    color: #fff;
    opacity: 1;
    background: hsla(0,0%,100%,.23);
}

.nav-link {
    color: #fff;
    display: block;
    padding: 10px 15px;
    margin: 5px 0px;
    opacity: .86;
    line-height: 30px;
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 600;
    cursor: pointer;
}

.nav-link i {
    font-size: 28px;
    margin-right: 15px;
    text-align: center;
    vertical-align: middle;
    float: left;
}

/* .hide {
    display: none;
}

.show {
    display: block;
} */

/* @media (max-width: 768px) { */
@media (max-width: 930px) {
    #sidebar {
        /* margin-left: -220px; */
        min-width: 80px;
        max-width: 80px;
        text-align: center;
    }

    /* #sidebar.active {
        margin-left: 0;
        min-width: 300px;
        max-width: 300px;
        min-height: 100vh;
        overflow: auto;
        display: block;
    } */

    /* .hide {
        display: none;
    }

    .show {
        display: block;
    } */

    #wide-logo {
        display: none;
    }

    #small-logo {
        display: block;
    }

    .nav-link i {
        margin: 0px;
        float: none;
    }

    .link-text {
        display: none;
    }
}
</style>
